import * as env from 'env';
export type Environment = 'development' | 'staging' | 'production';
export const ENV: Environment = env.NODE_ENV ?? 'development';
